import React, { useRef } from 'react';
import SelectRateOfCountryToSendDrawer from '../components/SelectRateOfCountryToSendDrawer';

const withSelectRateOfCountryToSend = (Component) => {
  const SelectRateOfCountryToSendComponent = (props) => {
    const drawerRef = useRef();

    const { remittanceRatesData, countries } = props || {};

    const newProps = {
      ...props,
    };
    return (
      <SelectRateOfCountryToSendDrawer
        ref={drawerRef}
        countries={countries}
        remittanceRatesData={remittanceRatesData}
        NavBarToggle={<Component {...newProps} />}
      />
    );
  };
  return SelectRateOfCountryToSendComponent;
};

export default withSelectRateOfCountryToSend;
